<button class="dialog-close-btn" type="button" (click)="ref.close()">
    <i class="pi pi-times"></i>
</button>
<div class="dialog-content">
    <div class="input-container" *ngIf="statusModal === 0">
        @if (type === 'discount' && currentDiscounts && currentDiscounts.discounts.length>0) {
            <app-input-form [icon]="undefined"
            [placeholder]="'schedulingForm.availableDiscounts' | transloco" type={{INPUT_TYPES.SELECT}} [value]="discountSelected" (valueChange)="selectDiscount($event)"
            [suggestions]="[]" [filterSelected]="false" [optionMapper]="optionMapperDiscount" [list]="listDiscounts"
            [lazy]="false"></app-input-form>
        }
        <app-input-form *ngIf="listPartners && listPartners.length>=0" [icon]="undefined"
            [placeholder]="'schedulingForm.selectPartner' | transloco" type={{INPUT_TYPES.SELECT}} [value]="partner"
            (valueChange)="selectPartner($event)" [suggestions]="[]" [filterSelected]="true"
            [optionMapper]="optionMapperProvider" [list]="listPartners" [lazy]="false"
            (search)="searchBenefits($event)"></app-input-form>
        <app-input-form *ngIf="partner && listServices.length>0" [icon]="undefined" [placeholder]="'schedulingForm.selectService' | transloco"
            type={{INPUT_TYPES.SELECT}} [value]="serviceSelected" (valueChange)="selectService($event)"
            [suggestions]="[]" [filterSelected]="true" [optionMapper]="optionMapperService" [list]="listServices"
            [lazy]="false" (search)="searchBenefits($event)"></app-input-form>
        <app-input-form *ngIf="serviceSelected && listSubServices.length>=0" [icon]="undefined"
            [placeholder]="'schedulingForm.selectSubService' | transloco" type={{getTypeSubService()}} [valueObject]="subServiceSelect"
            (valueChange)="selectSubService($event)" [suggestions]="[]" [filterSelected]="true"
            [optionMapper]="optionMapperSubService" [list]="listSubServices" [lazy]="false"
            (search)="searchBenefits($event)"></app-input-form>
        <app-input-form *ngIf="listVehicles && listVehicles.length>=0" [icon]="undefined"
            [placeholder]="'schedulingForm.vehiclePlate' | transloco" type={{INPUT_TYPES.SELECT}} [valueObject]="plate" (valueChange)="selectPlate($event)"
            [suggestions]="[]" [filterSelected]="true" [optionMapper]="optionMapperVehicle" [list]="listVehicles"
            [lazy]="false" (search)="searchBenefits($event)"></app-input-form>


        <app-input-form [icon]="undefined" [placeholder]="'common.scheduleService' | transloco" type={{INPUT_TYPES.DATE_PICKER}}
            [valueObject]="dateBenefit" (valueChange)="dateBenefit = $event" [suggestions]="[]"
            [showTime]="true"></app-input-form>

    </div>
    <div class="preview-bill" *ngIf="statusModal === 1">
        @if (type !== 'car-wash') {
        <div>
            <div class='element'>
                <span class='left'>{{ 'schedulingForm.service' | transloco }}:</span>
                <span>{{getServiceName()}}</span>
            </div>
            <p-divider></p-divider>
        </div>
        }
        <div>
            <div class='element'>
                <span class='left'>{{ 'schedulingForm.subService' | transloco }}:</span>
                <div class="subservice-list">
                    <div *ngFor="let element of getSubServiceSelected()">
                        <div class="field-price">
                            <span>{{element.name}}</span>
                            @if (type === 'car-wash') {
                            <span>{{ 'schedulingForm.free' | transloco }}</span>
                            } @else {
                            <span>{{element.price | customCurrency}}</span>
                            }
                        </div>
                        <p-divider></p-divider>
                    </div>
                </div>
            </div>
            <p-divider></p-divider>
        </div>
        <div>
            <div class='element'>
                <span class='left'>{{ 'schedulingForm.vehiclePlateLabel' | transloco }}:</span>
                <span>{{getVehicleName()}}</span>
            </div>
            <p-divider></p-divider>
        </div>
        <div>
            <div class='element'>
                <span class='left'>{{ 'schedulingForm.partner' | transloco }}:</span>
                <span>{{getPartnerName()}}</span>
            </div>
            <p-divider></p-divider>
        </div>
        <div>
            <div class='element'>
                <span class='left'>{{ 'schedulingForm.scheduledDate' | transloco }}:</span>
                <span>{{dateBenefit | date: 'dd/MM/yyyy'}}</span>
            </div>
        </div>
    </div>
    <div class="confirm-success" *ngIf="statusModal === 2">
        <div>
            <i class="pi pi-check-circle"></i>
            <span>{{ 'schedulingForm.successMessage' | transloco }}</span>
        </div>
        @if (type !== 'car-wash') {
        <div>
            <span>{{ 'schedulingForm.service' | transloco }}:</span>
            <span>{{getServiceName()}}</span>
        </div>
        }
        <div class="subservice-info">
            <span>{{ 'schedulingForm.subService' | transloco }}:</span>
            <div class="subservice-list">
                <div *ngFor="let element of getSubServiceSelected()">
                    <span>{{element.name}}: </span>
                    @if (type === 'car-wash') {
                    <span>{{ 'schedulingForm.free' | transloco }}</span>
                    } @else {
                    <span>{{element.price | customCurrency}}</span>
                    }
                </div>
            </div>
        </div>
        <div>
            <span>{{ 'schedulingForm.vehiclePlateLabel' | transloco }}:</span>
            <span>{{getVehicleName()}}</span>
        </div>
        <div>
            <span>{{ 'schedulingForm.partner' | transloco }}:</span>
            <span>{{getPartnerName()}}</span>
        </div>
        <div>
            <span>{{ 'schedulingForm.scheduledDate' | transloco }}:</span>
            <span>{{dateBenefit | date: 'dd/MM/yyyy'}}</span>
        </div>
        <div>
            <span>{{ 'schedulingForm.paymentStatus' | transloco }}:</span>
            <span>{{ 'schedulingForm.paid' | transloco }}</span>
        </div>
        <div>
            <span>{{ 'schedulingForm.totalPaid' | transloco }}:</span>
            <span>{{totalPrice | customCurrency}} COP</span>
        </div>
    </div>

    @if (type !== 'car-wash') {
    <div class="payment-info">
        <div>
            <i class="pi pi-credit-card"></i>
            <span>{{(statusModal === 0 || statusModal === 1) ? message[0].title : message[1].title}}</span>
        </div>
        <span>{{(statusModal === 0 || statusModal === 1) ? message[0].content : message[1].content}}</span>
    </div>


    <div *ngIf="(statusModal === 0 || statusModal === 1)">
        <p-divider></p-divider>
        <div class="sub-total">
            <span>{{ 'schedulingForm.total' | transloco }}:</span>
            <span>{{totalPrice | customCurrency}} COP</span>
        </div>
        <p-divider></p-divider>
    </div>
    }

    <div class="button-container">
        <button type="button" class="btn-general-black" (click)="createBenefit()">{{txtBtn}}</button>
    </div>
</div>